import { useSelector } from "react-redux"
import { RootState } from "../store/store"

const Questions = () => {
    const result = useSelector((state: RootState) => state.questions.questionnaire)
    const obj = result ? JSON.parse(JSON.stringify(result)) : []
    return obj
}

export default Questions